import { render, staticRenderFns } from "./ArqPeriodo.vue?vue&type=template&id=5dcc92a6&"
import script from "./ArqPeriodo.vue?vue&type=script&lang=js&"
export * from "./ArqPeriodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports